import { RIG_TRAIT_OPTIONS } from "@/generated/rig-catalog";
import { renderAiAvatar } from "@/lib/ai-avatar";
import type { Rarity, TraitSelection } from "@/types";

export const TRAIT_OPTIONS = RIG_TRAIT_OPTIONS;

const escapeXml = (value: string) =>
  value.replace(/[<>&"']/g, (character) => ({ "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&quot;", "'": "&apos;" })[character] ?? character);

export function buildAvatarSvg(traits: TraitSelection, background = 0, rarity: Rarity = "Unrevealed") {
  const label = `${TRAIT_OPTIONS.hair[traits.hair]} / ${TRAIT_OPTIONS.outfit[traits.outfit]} anime avatar`;
  return renderAiAvatar(traits, background, rarity, escapeXml(label));
}

export function svgDataUri(svg: string) {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

export function randomTraits(): TraitSelection {
  return {
    base: Math.floor(Math.random() * TRAIT_OPTIONS.base.length),
    eyes: Math.floor(Math.random() * TRAIT_OPTIONS.eyes.length),
    hair: Math.floor(Math.random() * TRAIT_OPTIONS.hair.length),
    hairColor: Math.floor(Math.random() * TRAIT_OPTIONS.hairColor.length),
    outfit: Math.floor(Math.random() * TRAIT_OPTIONS.outfit.length),
    accessory: Math.floor(Math.random() * TRAIT_OPTIONS.accessory.length),
    effect: Math.floor(Math.random() * TRAIT_OPTIONS.effect.length),
  };
}
